module.exports = __webpack_public_path__ + "static/speaker.39a8fec6.png";


//////////////////
// WEBPACK FOOTER
// ./src/components/About/Viewport/speaker.png
// module id = 677
// module chunks = 213534597649335